// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--eMWRA";
export var footerColumns = "footer-module--footerColumns--1RT8e";